(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/frejaeid-service.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/frejaeid-service.js');
"use strict";


const jupiter = svs.core.jupiter;
const logger = svs.playerLoginReact.logger;

const getFrejaeIdAuthRefTokenAsync = async isLogin => {
  logger.debug('In FrejaeIdService.getFrejaeIdAuthRefTokenAsync.');
  try {
    const options = {
      method: 'POST',
      path: '/player/1/frejaeid/initauth',
      data: {}
    };
    if (!isLogin) {
      options.data.newCustomer = true;
    }
    svs.components.Storage.browser.set('loginStartTime', 'player-login', Date.now(), svs.components.Storage.constants.EXPIRES_10M, () => {});
    const _await$jupiter$callAs = await jupiter.callAsync(options),
      response = _await$jupiter$callAs.response;
    return response.authRef;
  } catch (err) {
    if ((err === null || err === void 0 ? void 0 : err.code) === 1) {
      logger.warn('Error starting Freja eID login', err);
    } else {
      logger.info('Error starting Freja eID login', err);
    }
    throw err;
  }
};
const source = {
  'ios-hybrid-mobile': 5,
  'android-hybrid-mobile': 5,
  'ios-hybrid-tablet': 6,
  'web-mobile': 1,
  'web-tablet': 2,
  'web-desktop': 3
};


const pollCustomerLoginAsync = async authRef => {
  logger.debug('In FrejaeIdService.pollCustomerLoginAsync.');
  try {
    const options = {
      method: 'POST',
      path: '/player/1/frejaeid/getauthresult/login',
      data: {
        authRef,
        source: source[svs.core.data.capabilities.channel] || 1
      }
    };
    const _await$jupiter$callAs2 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs2.response;
    return response;
  } catch (err) {
    logger.info('Error polling freja eId login', err);
    throw err;
  }
};
const cancelCustomerLoginAsync = async authRef => {
  logger.debug('In FrejaeIdService.cancelCustomerLoginAsync.');
  try {
    const options = {
      method: 'POST',
      path: '/player/1/frejaeid/cancelauth',
      data: {
        authRef
      }
    };
    const response = await svs.core.jupiter.callAsync(options);
    logger.debug("Cancel poll: ".concat(response));
  } catch (error) {
    logger.info(error);
  }
};
svs.playerLoginReact.frejaeid.FrejaeIdService = {
  cancelCustomerLoginAsync,
  getFrejaeIdAuthRefTokenAsync,
  pollCustomerLoginAsync
};

 })(window);